import { Loading } from 'element-ui'

let overlay
let runningCount = 0

export default class {
  /**
   * Create new loading overlay
   */
  constructor () {
    this.delay = 400
    this.timer = null
    this.hasOverlay = false
  }

  /**
   * Start loading overlay
   */
  start () {
    // Start loading overlay after some time has passed
    // This avoids a short flash of the overlay if the connection is fast
    this.timer = setTimeout(() => {
      this.hasOverlay = true
      this.timer = null

      if (runningCount === 0) {
        overlay = Loading.service({ lock: true })
      }

      runningCount++
    }, this.delay)
  }

  /**
   * Stop loading overlay
   * Note: This doesn’t hide the overlay if another one is still running
   */
  stop () {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }

    if (this.hasOverlay) {
      this.hasOverlay = false
      runningCount--
    }

    if (runningCount === 0 && overlay && overlay.close) {
      overlay.close()
    }
  }
}
